import { useEffect, useRef } from "react";
import { map } from "./useMap.sideEffects";
import { CAMPUS_COLLECTION } from "../../../../reduxStore/actions/main";
import { stableEaseTo } from "../functions/interactivity.map";

export const useCampusChange = (
  setCurrentFloorNumber,
  currentCampusId,
  mapLoaded,
  currentFeature,
  start
) => {
  const featureRef = useRef(null);

  const setToGroundFloor = () => {
    if (!mapLoaded) return;

    const currentCampus = map.campusCollection.getCurrentCampus();
    currentCampus.floors.find((f) => f.isGroundFloor);
    const groundFloor = currentCampus.floors.find((f) => f.isGroundFloor);

    // Stichwort: Level6-Bug bei UKSH-iFrame
    // PH: Das hier sieht höchst verdächtig aus!
    // 1. setCurrentFloorNumber
    // 2. irgendwas mit Ground
    // 3. Kryptischer MK-Kommentar
    // 4. setTimeout!

    // Problem
    // Beim initialen laden muss der jeweilige Groundfloor gesetzt werden, initial ist das setCurrentFeature
    // schneller -> setzt seinen floor (auf POI level) -> dann kommt diese Funktion(ohne timeout), aber hat noch nicht die info
    // eines currentFeature. Auf eine bessere Lösung kam ich nicht
    // -> Das ist falsch!
    //
    // Lösung: nicht schön, aber wartet einfach bis setFeature fertig ist und setzt danach Groundfloor
    setTimeout(() => {
      if (groundFloor && groundFloor.stockwerk != null && !featureRef.current) {
        try {
          const startQuery = window.location.search
            .split("&")
            .find((s) => s.includes("start"));
          const [, res] = startQuery.split("=");
          const [lat, lng, z] = res.split("%2C");
          if (z && !Number.isNaN(+z)) {
            setCurrentFloorNumber(+z);
          }

          if (lat && lng && !Number.isNaN(+lat) && !Number.isNaN(+lng)) {
            stableEaseTo({ center: [lng, lat], duration: 1500 });
            setTimeout(() => {
              map.zoomTo(19, { duration: 1000 });

              if (z && !Number.isNaN(+z)) {
                setCurrentFloorNumber(+z);
              }
            }, 1600);
          }
          return;
        } catch (e) {}

        setCurrentFloorNumber(groundFloor.stockwerk);
      }
    }, 1000);
  };

  useEffect(() => {
    featureRef.current = currentFeature;
  }, [currentFeature]);
  useEffect(setToGroundFloor, [currentCampusId, mapLoaded]);
};
